import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OptimizelyDecideOption } from '@optimizely/react-sdk';
import getClient from '.';
import { getPrefixedKey } from './universal-credit';
var DECIDE_OPTIONS = [OptimizelyDecideOption.DISABLE_DECISION_EVENT];

/**
 * Gets an Object with key/value pairs of experiments and their variations
 * @param {string}  userId        The current user ID.
 * @param {object}  [attributes]  Optional attributes.
 *
 * @return {object} A key/value pairs object with experiments and their variations.
 */
export default ( /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId, attributes) {
    var _client$getOptimizely;
    var client, decisions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getClient();
        case 2:
          client = _context.sent;
          decisions = client.decideAll(DECIDE_OPTIONS, userId, attributes);
          Object.keys(decisions).forEach(function (key) {
            decisions[key] = decisions[key].variationKey;
          });

          // Support for legacy full stack experiments. Without this, the legacy experiments will not be populated in the redux store.
          Object.keys(((_client$getOptimizely = client.getOptimizelyConfig()) === null || _client$getOptimizely === void 0 ? void 0 : _client$getOptimizely.experimentsMap) || {}).forEach(function (experimentKey) {
            // Only call the legacy `getVariation` if it hasn't been resolved by `decideAll` which is the preferred method.
            if (!decisions[experimentKey]) {
              decisions[experimentKey] = client.getVariation(experimentKey, userId, attributes);
            }
          });
          Object.keys(decisions).forEach(function (key) {
            var prefixedKey = getPrefixedKey(key);
            if (prefixedKey !== key && decisions[prefixedKey]) {
              decisions[key] = decisions[prefixedKey];
            }
          });
          return _context.abrupt("return", decisions);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})());